$(document).ready(function () {
    $('#read-more').css({ "color": "#708a76", "cursor": "pointer" });
    $('#read-more').text('+ Read More').insertAfter('#product-description');
    completeString = $('#product-description').text();
    slicedString = completeString.substring(0, 50);
    $('#product-description').text(slicedString + '...');
    $('#read-more').click(function () {
        if ($(this).text() == "+ Read More") {
            $('#product-description').text(completeString);
            $(this).text('- Read Less');
        } else {
            $('#product-description').text(slicedString + '...');
            $(this).text('+ Read More');
        }
    })
});